const menu = [
  {
    id: 1,
    title: "Pudim Tradicional",
    price: 4.99,
    category: "Mais Pedidos",
    img: "./images/pudim-tradicional.jfif",
    description:
      "Pudim de leite tradicional, feito com leite integral, ovos e leite condensado integral, coberto por caramelo de açúcar.",
    stock: 10,
  },
  {
    id: 2,
    title: "Pudim de Café",
    price: 5.99,
    category: "Mais Pedidos",
    img: "./images/pudim-cafe.jpeg",
    description:
      "Pudim de leite com café, feito com leite integral, ovos e leite condensado, coberto por caramelo de açúcar e café.",
    stock: 1,
  },
  {
    id: 3,
    title: "Pudim de Chocolate Branco com Frutas Vermelhas",
    price: 5.99,
    category: "Mais Pedidos",
    img: "./images/pudim-frutas-vermelhas.jpg",
    description:
      "Pudim de leite com chocolate branco Galak, feito com leite integral, ovos e leite condensado, coberto por caramelo de açúcar e geleia de frutas vermelhas Queensberry™.",
    stock: 1,
  },
  {
    id: 4,
    title: "Pudim de Coco",
    price: 5.99,
    category: "Mais Pedidos",
    img: "./images/pudim-coco.jfif",
    description:
      "Pudim de leite, feito com leite integral, leite de coco, ovos e leite condensado, coberto por caramelo de açúcar e coco ralado.",
    stock: 1,
  },
  {
    id: 5,
    title: "Pudim de Limão",
    price: 5.99,
    category: "Mais Pedidos",
    img: "./images/pudim-limao.jpg",
    description:
      "Pudim de leite, feito com leite integral, raspas de casca de limão, ovos e leite condensado, coberto por caramelo de açúcar e suco de limão natural.",
    stock: 0,
  },
  {
    id: 6,
    title: "Pudim de Laranja",
    price: 5.99,
    category: "Mais Pedidos",
    img: "./images/pudim-laranja.jpg",
    description:
      "Pudim de leite, feito com leite integral, raspas de casca de laranja, ovos e leite condensado, coberto por caramelo de açúcar e suco de laranja natural.",
    stock: 1,
  },
  {
    id: 7,
    title: "Pudim de Baunilha",
    price: 5.99,
    category: "Mais Pedidos",
    img: "./images/pudim-baunilha.jpeg",
    description:
      "Pudim de leite, feito com leite integral, essência de baunilha, ovos e leite condensado integral, coberto por caramelo de açúcar.",
    stock: 1,
  },
  {
    id: 8,
    title: "Pudim de Morango",
    price: 5.99,
    category: "Mais Pedidos",
    img: "./images/pudim-morango.jfif",
    description:
      "Pudim de leite, feito com leite integral, compota de morangos, ovos e leite condensado integral, coberto por caramelo de açúcar e geleia de morango.",
    stock: 0,
  },
  {
    id: 9,
    title: "Pudim de Chocolate com Pimenta",
    price: 5.99,
    category: "Mais Pedidos",
    img: "./images/pudim-chocolate.jfif",
    description:
      "Pudim de leite, feito com leite integral, achocolatado, ovos e leite condensado integral, coberto por caramelo de açúcar e geleia de pimenta Queensberry™.",
    stock: 0,
  },
  {
    id: 10,
    title: "Pudim de Paçoca",
    price: 5.99,
    category: "Mais Pedidos",
    img: "./images/pudim-pacoca.jpg",
    description:
      "Pudim de leite, feito com leite integral, paçoca de amendoim, ovos e leite condensado integral, coberto por caramelo de açúcar.",
    stock: 1,
  },
];

export default menu;
